<template>
  <div class="processing-personal-data-agreement">
    {{phrases.TEXT_APPLY_PROCESS_PERSONAL_DATA}},
      <a href="/upload/docs/Pizza Prosto политика конфиденциальности.pdf" target="_blank">{{phrases.LINK_TEXT_PROCESSING_PERSONAL_DATE}}</a>
       {{phrases.AND}}
       {{phrases.WITH}}
      <a href="/upload/docs/Pizza Prosto пользовательское соглашение.pdf" target="_blank">{{phrases.LINK_TEXT_USER_AGREEMENT}}</a>
  </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  name: "Agreement",
  computed:{
    ...mapGetters('app', {
      phrases: 'getPhrases',
    }),
  }
}
</script>

<style scoped lang="scss">
  .processing-personal-data-agreement {
    position: relative;
    font-family: Panton, sans-serif;
    font-size: 0.875rem;
    line-height: 1.15rem;
    color: #fff;
    letter-spacing: .04rem;
    text-align: center;
    margin: 0.5rem 0;

    a {
      color: #fff;
      text-decoration: underline;
      &:hover {
        text-decoration-style: dashed;
      }
    }
  }
</style>